import type { SVGProps } from "react";

export const Pagerduty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="269"
    viewBox="0 0 268 269"
    width="268"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Pagerduty</title>
    <g clipPath="url(#clip0_268_754)">
      <path
        d="M219.611 0.434082H48.3889C21.6644 0.434082 0 22.0985 0 48.823V220.045C0 246.77 21.6644 268.434 48.3889 268.434H219.611C246.336 268.434 268 246.77 268 220.045V48.823C268 22.0985 246.336 0.434082 219.611 0.434082Z"
        fill="#26C152"
      />
      <path
        d="M68.0059 208.096H50.262V119.265C50.1585 115.992 50.724 112.732 51.9236 109.684C53.1233 106.636 54.9323 103.865 57.2401 101.539C62.1251 97.0341 68.5355 94.5439 75.1834 94.5674H103.095C113.063 94.5674 118.845 98.5509 121.836 101.937C126.132 106.814 128.35 113.175 128.016 119.663V153.125C128.016 162.685 124.029 168.461 120.839 171.648C115.966 175.975 109.61 178.258 103.095 178.021H68.0059V208.096ZM103.494 160.295C105.285 160.323 107.036 159.764 108.478 158.701C109.107 157.928 109.573 157.035 109.848 156.076C110.122 155.118 110.198 154.114 110.073 153.125V118.668C110.133 116.874 109.57 115.114 108.478 113.688C106.822 112.444 104.756 111.875 102.696 112.095H74.7844C67.8067 112.095 67.8067 117.472 67.8067 119.066V160.295H103.494ZM193.01 174.436H165.099C155.13 174.436 149.548 170.453 146.358 167.067C142.116 162.158 139.906 155.819 140.178 149.34V115.879C140.001 112.461 140.548 109.043 141.785 105.851C143.022 102.659 144.92 99.7643 147.355 97.3561C152.259 93.0811 158.593 90.8061 165.099 90.9825H199.988V61.1064H217.732V149.739C217.86 153.015 217.305 156.282 216.104 159.333C214.903 162.384 213.081 165.153 210.754 167.465C205.92 171.923 199.589 174.41 193.01 174.436ZM157.921 150.336C157.877 152.128 158.439 153.882 159.516 155.316C161.172 156.559 163.239 157.129 165.298 156.909H193.21C200.188 156.909 200.188 151.531 200.188 149.938V108.908H164.7C162.904 108.848 161.143 109.411 159.716 110.501C159.086 111.275 158.62 112.168 158.346 113.126C158.072 114.085 157.995 115.089 158.121 116.078L157.921 150.336Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_268_754">
        <rect
          fill="white"
          height="268"
          transform="translate(0 0.434082)"
          width="268"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Pagerduty;
